import {connect} from 'react-redux';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {TABLET_BREAKPOINT} from '../../utils/constants';
import PopularDestinationsComponent from './PopularDestinations';
import {fetchImages} from './redux';
import {
    ACTION_LOCATION,
    pushHandlerClickData,
    pushHandlerNext,
    pushHandlerPrev,
} from './events';

function replaceTemplateString(template, showUpdatedPopularDestinations, res) {
    if (showUpdatedPopularDestinations) {
        return (template || '').replace('${templateId}', `${res}`);
    }
    return (template || '').replace('${templateId}', `carousel-${res}`);
}

function getLbsIds(items = []) {
    return items.map(({lbsId}) => lbsId);
}

function ensureCorrectSize(
    popularDestinations,
    showUpdatedPopularDestinations
) {
    if (showUpdatedPopularDestinations) {
        return popularDestinations.slice(0, 5);
    }

    return popularDestinations.length >= 4
        ? popularDestinations.slice(0, 10)
        : [];
}

function getPopularDestinations(
    items = [],
    images = [],
    showUpdatedPopularDestinations = false
) {
    const imagesById = images.reduce(
        (acc, item) => ({
            ...acc,
            [item.key]: item.urlTemplate,
        }),
        {}
    );

    const popularDestinations = items.reduce((acc, item) => {
        const urlTemplate = imagesById[item.lbsId];

        if (urlTemplate) {
            acc.push({
                ...item,
                getImageUrl: replaceTemplateString.bind(
                    null,
                    urlTemplate,
                    showUpdatedPopularDestinations
                ),
            });
        }

        return acc;
    }, []);

    return ensureCorrectSize(
        popularDestinations,
        showUpdatedPopularDestinations
    );
}

function getFilteredLbsIds(destinationImages = []) {
    let cardTitlesDisplayed = [];
    let cardTitlesLoaded = [];

    destinationImages.forEach((item) => {
        if (item.urlTemplate) {
            cardTitlesDisplayed.push(item.key);
        } else {
            cardTitlesLoaded.push(item.key);
        }
    });

    return {
        cardTitlesDisplayed: cardTitlesDisplayed.join(','),
        cardTitlesLoaded: cardTitlesLoaded.join(','),
    };
}

const mapDispatchToProps = {
    fetchImages,
};

function mapStateToProps({destination, config, options, search}) {
    const {locality, details, destinationImages} = destination;
    const {showUpdatedPopularDestinations} = options;
    const cityCarouselTitle = locality.title || '';
    const lbsIds = getLbsIds(locality.carousel);
    const popularDestinations = getPopularDestinations(
        locality.carousel,
        destinationImages,
        showUpdatedPopularDestinations
    );
    const {cardTitlesDisplayed, cardTitlesLoaded} = getFilteredLbsIds(
        destinationImages
    );

    return {
        basePath: config.site.basePath,
        basePathPrefix: config.url.basePathPrefix,
        cityCarouselTitle,
        host: config.site.domain,
        lbsIds,
        cardTitlesDisplayed,
        cardTitlesLoaded,
        popularDestinations,
        search,
        simpleName: (details && details.simpleName) || '',
        showUpdatedPopularDestinations,
        ACTION_LOCATION,
        pushHandlerClickData,
        pushHandlerNext,
        pushHandlerPrev,
    };
}

export const PopularDestinations = connect(
    mapStateToProps,
    mapDispatchToProps
)(determineIfMobile(PopularDestinationsComponent, TABLET_BREAKPOINT));

PopularDestinations.displayName = 'PopularDestinations';

export default PopularDestinations;
